<mat-label class="subHeading">{{config.label}}<span *ngIf="config.required" class="star">*</span></mat-label>

<div [formGroup]="rangeForm" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
